// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.privacy-policy {
    padding: 50px;
}

.privacy-policy h1 {
    color: #2B2B2B;
    font-size: 30px;
    font-weight: 300;
    line-height: 50px;
    margin-bottom: 20px;
    position: relative;
}

.privacy-policy h1:after {
    background: #004ba0;
    content: '';
    display: block;
    height: 2px;
    margin-top: 5px;
}

.privacy-policy h2 {
    color: #2B2B2B;
    font-size: 25px;
    line-height: 50px;
    margin-bottom: 25px;
    position: relative;
}

.privacy-policy p {
    color: #353634;
    font-size: 18px;
    font-weight: 500;
    line-height: 36px;
    margin-bottom: 15px;
    text-align: justify;
}

.privacy-policy a {
    color: #004ba0;
    font-style: normal;
}

.privacy-policy a:hover {
    color: #353634;
}

/*for mobile*/
@media only screen and (max-width: 650px) {
    .privacy-policy {
        padding: 10px;
    }
}`, "",{"version":3,"sources":["webpack://./src/home/css/privacy-policy.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,cAAc;IACd,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA,aAAa;AACb;IACI;QACI,aAAa;IACjB;AACJ","sourcesContent":[".privacy-policy {\n    padding: 50px;\n}\n\n.privacy-policy h1 {\n    color: #2B2B2B;\n    font-size: 30px;\n    font-weight: 300;\n    line-height: 50px;\n    margin-bottom: 20px;\n    position: relative;\n}\n\n.privacy-policy h1:after {\n    background: #004ba0;\n    content: '';\n    display: block;\n    height: 2px;\n    margin-top: 5px;\n}\n\n.privacy-policy h2 {\n    color: #2B2B2B;\n    font-size: 25px;\n    line-height: 50px;\n    margin-bottom: 25px;\n    position: relative;\n}\n\n.privacy-policy p {\n    color: #353634;\n    font-size: 18px;\n    font-weight: 500;\n    line-height: 36px;\n    margin-bottom: 15px;\n    text-align: justify;\n}\n\n.privacy-policy a {\n    color: #004ba0;\n    font-style: normal;\n}\n\n.privacy-policy a:hover {\n    color: #353634;\n}\n\n/*for mobile*/\n@media only screen and (max-width: 650px) {\n    .privacy-policy {\n        padding: 10px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
